import Vue from 'vue'
import Router from 'vue-router'
import App from '../App'

// index
const index = () => import('@/pages/index/index')
const home = () => import('@/pages/index/home/home')
const video = () => import('@/pages/index/video/video')
const member = () => import('@/pages/index/member/member')
const community = () => import('@/pages/index/community/community')

// detail
const article = () => import('@/pages/detail/article/article')
const post = () => import('@/pages/detail/post/post')

// member下
const friend = () => import('@/pages/friend/friend')
const homepage = () => import('@/pages/index/member/homepage/homepage')
const follow = () => import('@/pages/index/member/follow/follow')
const circle = () => import('@/pages/index/member/circle/circle')
const myPosts = () => import('@/pages/index/member/myPosts/myPosts')
const collection = () => import('@/pages/index/member/collection/collection')
const news = () => import('@/pages/index/member/news/news')
const rewardDetailed = () => import('@/pages/index/member/rewardDetailed/rewardDetailed')
const setting = () => import('@/pages/index/member/setting/setting')
const opinion = () => import('@/pages/index/member/opinion/opinion')
const comment = () => import('@/pages/index/member/news/comment/comment')
const consumption = () => import('@/pages/index/member/news/consumption/consumption')
const fabulous = () => import('@/pages/index/member/news/fabulous/fabulous')
const friends = () => import('@/pages/index/member/news/friends/friends')
const account = () => import('@/pages/index/member/setting/account/account')
const software = () => import('@/pages/index/member/setting/software/software')
const address = () => import('@/pages/index/member/setting/address/address')
const mianze = () => import('@/pages/index/member/setting/software/mianze/mianze')
const material = () => import('@/pages/index/member/homepage/material/material')
const binding = () => import('@/pages/index/member/homepage/material/binding/binding')
const bindEmail = () => import('@/pages/index/member/homepage/material/bindEmail/bindEmail')
const bindingNew = () => import('@/pages/index/member/homepage/material/bindingNew/bindingNew')
const bindEmailNew = () => import('@/pages/index/member/homepage/material/bindEmailNew/bindEmailNew')
const modifyName = () => import('@/pages/index/member/homepage/material/modifyName/modifyName')
const wallet = () => import('@/pages/index/member/wallet/wallet')
const assets = () => import('@/pages/index/member/assets/assets')
const sign = () => import('@/pages/index/member/sign/sign')
const grade = () => import('@/pages/index/member/grade/grade')
const rewardRule = () => import('@/pages/index/member/grade/rewardRule/rewardRule')
const assetDetailed = () => import('@/pages/index/member/wallet/assetDetailed/assetDetailed')
const modifyAutograph = () => import('@/pages/index/member/homepage/material/modifyAutograph/modifyAutograph')
const addressIndex = () => import('@/pages/index/member/homepage/material/addressIndex/addressIndex')
const dataEdit = () => import('@/pages/index/member/homepage/material/dataEdit/dataEdit')
const myFans = () => import('@/pages/index/member/homepage/myFans/myFans')
const fans = () => import('@/pages/friend/fans/fans')
const chatDetail = () => import('@/pages/chat/detail/detail')
const loginPassword = () => import('@/pages/index/member/setting/account/loginPassword/loginPassword')
const modifyAddress = () => import('@/pages/modifyAddress/modifyAddress')

// 其它
const playVideo = () => import('@/pages/playVideo/playVideo')
const tagThem = () => import('@/pages/tagThem/tagThem')
const detailsTheme = () => import('@/pages/detailsTheme/detailsTheme')
const chat = () => import('@/pages/chat/chat')
const login = () => import('@/pages/login/login')
const emailLogin = () => import('@/pages/login/emailLogin')
const mianzes = () => import('@/pages/login/mianze')
const autopay = () => import('@/pages/login/autopay')
const Privacy = () => import('@/pages/login/privacy')
const loginMessage = () => import('@/pages/loginMessage/loginMessage')
const userReport = () => import('@/pages/userReport/userReport')
const error = () => import('@/pages/error/error')
const postReport = () => import('@/pages/postReport/postReport')
const adIndex = () => import('@/pages/ad/ad')
const todayHot = () => import('@/pages/todayHot/todayHot')
const theme = () => import('@/pages/theme/theme')
const myTheme = () => import('@/pages/myTheme/myTheme')
const newTheme = () => import('@/pages/newTheme/newTheme')
const moneyRecharge = () => import('@/pages/moneyRecharge/moneyRecharge')
const recharge = () => import('@/pages/recharge/recharge')
const articleLabel = () => import('@/pages/articleLabel/articleLabel')

// 发布
const releaseCharacters = () => import('@/pages/release/releaseCharacters')
const releaseMessage = () => import('@/pages/release/releaseMessage')
const releaseTinyVideo = () => import('@/pages/release/releaseTinyVideo')
const releaseVideo = () => import('@/pages/release/releaseVideo')
const releaseRideo = () => import('@/pages/release/releaseRideo')

// 商城
const shop = () => import('@/pages/shop/shop')
const myOrders = () => import('@/pages/shop/myOrders/myOrders')
const details = () => import('@/pages/shop/details/details')
const orderSee = () => import('@/pages/shop/orderSee/orderSee')
const recharegePayment = () => import('@/pages/shop/rechargePayment/rechargePayment')
const orderSubmit = () => import('@/pages/shop/orderSubmit/orderSubmit')

// 音频
const radio = () => import('@/pages/radio/index')
const radios = () => import('@/pages/radio/radio/radio')
const radioDetails = () => import('@/pages/radio/details/details')

// 搜索
const search = () => import('@/pages/search/search')
const searchUser = () => import('@/pages/search/searchUser')
const searchArticle = () => import('@/pages/search/searchArticle')
const searchTopic = () => import('@/pages/search/searchTopic')

// 注册
const register = () => import('@/pages/register/register')
const registerOne = () => import('@/pages/register/registerOne')
const registerTwo = () => import('@/pages/register/registerTwo')
const recommendFollow = () => import('@/pages/register/recommendFollow') //推荐关注页
const bindPhone = () => import('@/pages/bindPhone/bindPhone')
const bindPhoneOne = () => import('@/pages/bindPhone/bindPhoneOne')

// 忘记密码
const forgetPassword = () => import('@/pages/forgetPassword/forgetPassword')
const forgetPasswordOne = () => import('@/pages/forgetPassword/forgetPasswordOne')

// about
const termsOfService = () => import('@/pages/about/termsOfService')
const privacyPolicy = () => import('@/pages/about/privacyPolicy')

// redifree
const redifree = () => import('@/pages/redifree/index')
const redifreeIndex = () => import('@/pages/redifree/home/home')
const redifreeArea = () => import('@/pages/redifree/area/area')
const chooseArea = () => import('@/pages/redifree/area/modules/areaChoose')
const redifreeFavorites = () => import('@/pages/redifree/favorites/favorites')
const redifreeUser = () => import('@/pages/redifree/user/user')
const redifreeInformation = () => import('@/pages/redifree/information/information')
const redifreeUsageClause = () => import('@/pages/redifree/usageClause/usageClause')
const redifreeTobuy = () => import('@/pages/redifree/buy/buy')
const redifreeCompany = () => import('@/pages/redifree/company/company')
const redifreeProgram = () => import('@/pages/redifree/program/program')

//下载
const downloadindex = () => import('@/pages/downloadindex/downloadindex')

Vue.use(Router)
export default new Router({
  // scrollBehavior (to, from, savedPosition) {
  //   if (to.name === 'index' || to.name === 'community' || to.name === 'video' || to.name === 'member') {
  //     let scroll = 0
  //     if (document.documentElement && document.documentElement.scrollTop) {
  //       scroll = document.documentElement.scrollTop
  //     } else {
  //       scroll = document.body.scrollTop
  //     }
  //     if (from.name === 'index' || from.name === 'community' || from.name === 'video' || from.name === 'member') {
  //       sessionStorage.setItem(from.name, scroll)
  //     }
  //     if (sessionStorage.getItem(to.name)) {
  //       return {x: 0, y: parseInt(sessionStorage.getItem(to.name))}
  //     } else {
  //       return {x: 0, y: 0}
  //     }
  //   }
  //   return {x: 0, y: 0}
  // },
  routes: [{
    path: '',
    redirect: '/index/home',
    component: App,
    children: [
      // index
      {
        name: 'index',
        path: '/index',
        component: index,
        redirect: '/index/home',
        children: [
          {
            name: 'home',
            path: 'home',
            component: home
          },
          {
            name: 'video',
            path: 'video',
            component: video
          },
          {
            name: 'community',
            path: 'community',
            component: community
          },
          {
            name: 'member',
            path: 'member',
            component: member,
            meta: {
              requireAuth: true
            },
            children: [
              {
                name: 'homepage',
                path: 'homepage',
                component: homepage,
                children: [
                  {
                    name: 'material',
                    path: 'material',
                    component: material,
                    children: [
                      {
                        name: 'binding',
                        path: 'binding',
                        component: binding
                      },
                      {
                        name: 'bindEmail',
                        path: 'bind-email',
                        component: bindEmail
                      },
                      {
                        name: 'bindingNew',
                        path: 'binding-new',
                        component: bindingNew
                      },
                      {
                        name: 'bindEmailNew',
                        path: 'bindEmail-new',
                        component: bindEmailNew
                      },
                      {
                        name: 'modifyName',
                        path: 'modify-name',
                        component: modifyName
                      },
                      {
                        name: 'modifyAutograph',
                        path: 'modify-autograph',
                        component: modifyAutograph
                      },
                      {
                        name: 'addressIndex',
                        path: 'addressIndex',
                        component: addressIndex
                      },
                      {
                        name: 'dataEdit',
                        path: 'data-edit',
                        component: dataEdit
                      }
                    ]
                  },
                  {
                    name: 'myFans',
                    path: 'my-fans',
                    component: myFans
                  }
                ]
              },
              {
                name: 'follow',
                path: 'follow',
                component: follow
              },
              {
                name: 'circle',
                path: 'circle',
                component: circle
              },
              {
                name: 'myPosts',
                path: 'myPosts',
                component: myPosts
              },
              {
                name: 'collection',
                path: 'collection',
                component: collection
              },
              {
                name: 'news',
                path: 'news',
                component: news,
                children: [
                  {
                    name: 'fabulous',
                    path: 'fabulous',
                    component: fabulous
                  },
                  {
                    name: 'comment',
                    path: 'comment',
                    component: comment
                  },
                  {
                    name: 'friends',
                    path: 'friends',
                    component: friends
                  },
                  {
                    name: 'consumption',
                    path: 'consumption',
                    component: consumption
                  }
                ]
              },
              {
                name: 'rewardDetailed',
                path: 'rewardDetailed',
                component: rewardDetailed
              },
              {
                name: 'setting',
                path: 'setting',
                component: setting,
                children: [
                  {
                    name: 'account',
                    path: 'account',
                    component: account,
                    children: [
                      {
                        name: 'loginPassword',
                        path: 'login-password',
                        component: loginPassword
                      },
                      {
                        path: 'binding',
                        component: binding
                      },
                      {
                        path: 'bind-email',
                        component: bindEmail
                      },
                      {
                        path: 'binding-New',
                        component: bindingNew
                      },
                      {
                        path: 'bindEmail-New',
                        component: bindEmailNew
                      }
                    ]
                  },
                  {
                    name: 'software',
                    path: 'software',
                    component: software,
                    children: [
                      {
                        name: 'mianze',
                        path: 'mianze',
                        component: mianze
                      }
                    ]
                  },
                  {
                    name: 'address',
                    path: 'address',
                    component: address
                  }
                ]
              },
              {
                name: 'opinion',
                path: 'opinion',
                component: opinion
              },
              {
                path: 'assets',
                component: assets
              },
              {
                name: 'wallet',
                path: 'wallet',
                component: wallet,
                children: [
                  {
                    name: 'assetDetailed',
                    path: 'asset-detailed',
                    component: assetDetailed
                  },
                  {
                    path: 'reward-detailed',
                    component: rewardDetailed
                  }
                ]
              },
              {
                name: 'sign',
                path: 'sign',
                component: sign,
                meta: {
                  requireAuth: true
                }
              },
              {
                name: 'grade',
                path: 'grade',
                component: grade,
                children: [
                  {
                    name: 'rewardRule',
                    path: 'reward-rule',
                    component: rewardRule
                  }
                ]
              }
            ]
          }
        ]
      },
      // 商城
      {
        name: 'shop',
        path: '/shop',
        component: shop,
        children: [
          {
            name: 'myOrders',
            path: 'my-orders',
            component: myOrders,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'orderSee',
            path: 'order-see',
            component: orderSee,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'rechargePayment',
            path: 'recharge-payment',
            component: recharegePayment,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'details',
            path: 'details',
            component: details
          },
          {
            name: 'orderSubmit',
            path: 'order-submit',
            component: orderSubmit,
            meta: {
              requireAuth: true
            }
          },
          {
            name: 'assets',
            path: 'assets',
            component: assets,
            meta: {
              requireAuth: true
            }
          }
        ]
      },
      // 音频
      {
        name: 'radio',
        path: '/radio',
        component: radio,
        redirect: '/radio/radios',
        children: [
          {
            name: 'radios',
            path: 'radios',
            component: radios
          },
          {
            name: 'details',
            path: 'details',
            component: radioDetails
          },
          {
            name: 'community',
            path: 'community',
            component: community
          }
        ]
      },
      // detail
      {
        name: 'article',
        path: '/article',
        component: article
      },
      {
        name: 'post',
        path: '/post',
        component: post
      },
      // 其它
      {
        name: 'friend',
        path: '/friend',
        component: friend,
        children: [
          {
            name: 'fans',
            path: 'fans',
            component: fans
          }
        ]
      },
      {
        name: 'playVideo',
        path: '/play-video',
        component: playVideo
      },
      {
        name: 'tagTheme',
        path: '/tag-theme',
        component: tagThem
      },
      {
        name: 'detailsTheme',
        path: '/details-theme',
        component: detailsTheme
      },
      {
        name: 'releaseCharacters',
        path: '/release-characters',
        component: releaseCharacters,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'releaseThemMessage',
        path: '/release-them-message',
        component: releaseMessage,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'releaseMessage',
        path: '/release-message',
        component: releaseMessage,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'releaseTinyVideo',
        path: '/release-tinyVideo',
        component: releaseTinyVideo,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'releaseVideo',
        path: '/release-video',
        component: releaseVideo,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'releaseRideo',
        path: '/release-rideo',
        component: releaseRideo,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'chat',
        path: '/chat',
        component: chat,
        meta: {
          requireAuth: true
        },
        children: [
          {
            name: 'detail',
            path: 'detail',
            component: chatDetail
          }
        ]
      },
      {
        name: 'login',
        path: '/login',
        component: login
      },
      {
        name: 'emailLogin',
        path: '/emailLogin',
        component: emailLogin
      },
      {
        name: 'mianzes',
        path: '/mianzes',
        component: mianzes
      },
      {
        name: 'autopay',
        path: '/autopay',
        component: autopay
      },
      {
        name: 'Privacy',
        path: '/Privacy',
        component: Privacy
      },
      {
        name: 'loginMessage',
        path: '/login-message',
        component: loginMessage
      },
      {
        name: 'search',
        path: 'search',
        component: search
      },
      {
        name: 'searchUser',
        path: 'search-user',
        component: searchUser
      },
      {
        name: 'searchTopic',
        path: 'search-topic',
        component: searchTopic
      },
      {
        name: 'searchArticle',
        path: 'search-article',
        component: searchArticle
      },
      {
        path: 'address',
        component: address
      },
      {
        name: 'userReport',
        path: 'user-report',
        component: userReport,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'error',
        path: 'error',
        component: error,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'postReport',
        path: 'post-report',
        component: postReport,
        meta: {
          requireAuth: true
        }
      },
      // 广告
      {
        path: '/adindex/:url/:title',
        component: adIndex
      },
      // 注册
      {
        name: 'register',
        path: '/register',
        component: register
      },
      {
        name: 'registerOne',
        path: '/register-one',
        component: registerOne
      },
      {
        name: 'registerTwo',
        path: '/register-two',
        component: registerTwo
      },
      {
        name: 'recommendFollow',
        path: '/recommendFollow',
        component: recommendFollow
      },
      {
        name: 'bindPhone',
        path: 'bind-phone',
        component: bindPhone
      },
      {
        name: 'bindPhoneOne',
        path: 'bind-phone-one',
        component: bindPhoneOne
      },
      // 忘记密码
      {
        name: 'forgetPassword',
        path: 'forget-password',
        component: forgetPassword
      },
      {
        name: 'forgetPasswordOne',
        path: 'forget-password-one',
        component: forgetPasswordOne
      },
      // about
      {
        name: 'termsOfService',
        path: 'terms-of-service',
        component: termsOfService
      },
      {
        name: 'privacyPolicy',
        path: 'privacy-policy',
        component: privacyPolicy
      },
      {
        name: 'todayHot',
        path: 'today-hot',
        component: todayHot
      },
      {
        name: 'theme',
        path: 'theme',
        component: theme
      },
      {
        name: 'newTheme',
        path: 'new-theme',
        component: newTheme
      },
      {
        name: 'myTheme',
        path: 'my-theme',
        component: myTheme,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'moneyRecharge',
        path: '/money-recharge',
        component: moneyRecharge,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'recharge',
        path: '/recharge',
        component: recharge,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/modify-address',
        component: modifyAddress,
        meta: {
          requireAuth: true
        }
      },
      {
        name: 'articleLabel',
        path: '/article-label',
        component: articleLabel
      },
      // redifree
      {
        name: 'redifree',
        path: '/redifree',
        component: redifree,
        redirect: '/redifree/home',
        children: [
          {
            name: 'home',
            path: 'home',
            component: redifreeIndex
          },
          {
            name: 'area',
            path: 'area',
            component: redifreeArea
          }, {
            name: 'chooseArea',
            path: 'chooseArea',
            component: chooseArea
          },
          {
            name: 'redifreeFavorites',
            path: 'redifreeFavorites',
            component: redifreeFavorites
          },
          {
            name: 'user',
            path: 'user',
            meta:{requireAuth:true},
            component: redifreeUser
          },
          {
            name: 'information',
            path: 'information',
            component: redifreeInformation
          },
          // redifreeInformation
          {
            name: 'usageClause',
            path: 'usageClause',
            component: redifreeUsageClause
          },
          // redifreeUsageClause
          {
            name: 'buy',
            path: 'buy',
            component: redifreeTobuy
          },
          // redifreeTobuy
          {
            name: 'company',
            path: 'company',
            component: redifreeCompany
          },
          // redifreeCompany
          {
            name: 'program',
            path: 'program',
            component: redifreeProgram
          },
          // redifreeProgram
          {
            name: 'downloadindex',
            path: '/downloadindex',
            component: downloadindex
          }
        ]
      }
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js